import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Table, Button, Icon } from 'semantic-ui-react';

export const Container = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0% auto;
  padding-bottom:80px;
  padding-left:1rem;
  padding-right:1rem;
  background: #FFFFFF;
`;

export const Title =  styled.h1`
  width: 100%;
  max-width: 1100px;
  
  margin:0px auto 15px auto;
  padding-bottom: 5px;

  color:#000000;

  border-bottom: 1px solid rgba(0, 0, 0, .15);

  font-size:28px;
  font-family:sans-serif;
  font-weight:600;
`;

export const SelectItemGeradorCertificado = styled.div`
  width:100%;
  height:100%;
  background-color: rgba(0,0,0,0.8);
  color:white;
  img{
    border:1px solid white;
  }
  display:flex;
  flex-direction:row;
  padding:10px;
  align-items:center;
`
export const ValorFinal = styled.div`
  width:100%;
  min-height:50px;
  background-color:black;
  position:fixed;
  bottom:0px;
  left:0px;
  display:flex;
  justify-content:center;
  flex-direction:column;
  align-items:center;
  padding:10px;
  p,b{
    font-size:16px;
    color:white;
    line-height:16px;
  }
`